import React from 'react';

import { useParams } from 'react-router-dom';
import { Link } from '~/lib/react-router-dom';

import { Alert, Box, Button, Stack } from '@mui/material';
import List from '@mui/material/List';

import Spinner from '~/components/Common/Spinner';

import { useGetBundleItems } from '~/hooks/apis/cruises/useGetBundleItems';

import BundlesItemCreate from './BundlesItemCreate';
import BundlesItemListItem from './BundlesItemListItem';

function BundlesItemList() {
  const { bundleId, action } = useParams<{ bundleId: string; action?: string }>();

  const { data: bundleItems = [], isLoading, error } = useGetBundleItems(bundleId);

  if (isLoading) {
    return <Spinner size={30} />;
  }

  if (error) {
    return <Alert severity="error">Error loading bundle items: {error.message}</Alert>;
  }

  return (
    <Box mt={1}>
      <Box>
        <List>
          {bundleItems.map((bundleItem) => (
            <BundlesItemListItem key={bundleItem.id} bundleItem={bundleItem} />
          ))}
        </List>
      </Box>

      <Stack
        mt={2}
        width="100%"
        direction="row"
        justifyContent="flex-end"
        paddingLeft={2}
        paddingRight={2}
        paddingBottom={1}
      >
        <Button
          component={Link}
          to={`/cruises/bundles/edit/${bundleId}/items/create`}
          variant="outlined"
          size="small"
          fullWidth
        >
          Add Bundle Item
        </Button>
      </Stack>

      {action === 'create' && <BundlesItemCreate />}
    </Box>
  );
}

export default BundlesItemList;
